import { AUTH_API, handleApiError } from '../../utils/axios';

export const getBrands = async (search, unpaged) => {
  try {
    const url = unpaged
      ? `/api/v1/brands?search=${search.search}`
      : `/api/v1/brands?page=${search.page}&size=${search.size}&search=${search.search}`;
    const { data } = await AUTH_API.get(url);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getBrand = async (brandId) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/brands/${brandId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createBrand = async (brand) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/brands`, brand);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateBrand = async (brand) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/brands/${brand.id}`, brand);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteBrand = async (brandId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/brands/${brandId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
